import { useRef, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

import { RiContactsFill } from "react-icons/ri";
import { FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";

import "../styles/main.scss";

import NavBar from "../components/navBar";
import Footer from "../components/footer";

import Home from "./sections/home";
import AboutUs from "./sections/aboutUs";
import OurExpertise from "./sections/e";
import OutsourcingSolutions from "./sections/s";
import Contact from "./sections/contact";
import Careers from "./sections/careers";

import data from "../data/data.json";
import languageEs from "../data/language/es.json";
import languageEn from "../data/language/en.json";

const tabRoutes = {
  0: "/",
  1: "/our-expertise",
  2: "/outsourcing-solutions",
  3: "/contact",
  4: "/about-us",
  5: "/careers",
};

const getTabFromPath = (pathname) => {
  const tabEntry = Object.entries(tabRoutes).find(([, route]) => route === pathname);
  return tabEntry ? Number(tabEntry[0]) : 0;
};

function Main() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState(() => getTabFromPath(window.location.pathname));
  const [answer, setAns] = useState(false);
  const [typeUser, setTypeUser] = useState(""); // "user" o "company"
  const [language, setLanguage] = useState("en"); // "en" o "es"
  const textContent =
    language === "en"
      ? languageEn
      : language === "es"
      ? languageEs
      : languageEn;
  const [contactBtn, setcontactBtn] = useState(false);

  //console.log("Current language:", textContent.hero.headline);

  const welcomeMsg = useRef(null);

  const handleTabChange = (nextTab) => {
    setTab(nextTab);
    navigate(tabRoutes[nextTab]);
  };

  const openModal = (currentModal) => {
    if (currentModal == null) return;
    currentModal.showModal();
  };

  const closeModal = (currentModal) => {
    currentModal.close();
  };

  useEffect(() => {
    setTab(getTabFromPath(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    setTimeout(() => {
      openModal(welcomeMsg.current);
    }, 500);
  }, []);

  function WelcomeMsg() {
    return (
      <div class={typeUser === "" ? "overlay" : ""} id="welcomeOverlay">
        <dialog ref={welcomeMsg} className="modal-content">
          <h1>{textContent?.welcomeBanner?.headline}</h1>
          <p>{textContent?.welcomeBanner?.description}</p>

          <div className="selection-buttons">
            <button
              className="btn-primary"
              onClick={() => {
                closeModal(welcomeMsg.current);
                setTypeUser("company");
              }}
            >
              {textContent?.welcomeBanner?.ctaCompany}
            </button>
            <button
              className="btn-secondary"
              onClick={() => {
                closeModal(welcomeMsg.current);
                setTypeUser("user");
              }}
            >
              {textContent?.welcomeBanner?.ctaJobSeeker}
            </button>
          </div>
        </dialog>
      </div>
    );
  }

  return (
    <>
      <section key={tab} className={`hero hero-${tab}`}>
        <h1>{textContent?.hero?.headline}</h1>
        <img
          src="logo512tr.png"
          alt="heroImg"
          className="a"
          draggable="false"
        />

        <AnimatePresence>
          {typeUser === "" ? (
            <motion.div
              className="welcome-text"
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{
                y: 50,
                opacity: 0,
                transition: { duration: 0.5, delay: 0 }, // salida sin delay
              }}
              transition={{ duration: 0.5, delay: 1.5 }} // delay SOLO para entrada
            >
              <h1>{textContent?.welcomeBanner?.headline}</h1>
              <p>{textContent?.welcomeBanner?.description}</p>
              <button
                onClick={() => {
                  setTypeUser("company");
                }}
              >
              {textContent?.welcomeBanner?.ctaCompany}
              </button>
              <button
                onClick={() => {
                  {setTypeUser("user") 
                    setTab(5)}
                }}
              >
              {textContent?.welcomeBanner?.ctaJobSeeker}
              </button>
            </motion.div>
          ) : null}
        </AnimatePresence>

        <div
          className="footer-hero"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img src="logo.png" alt="heroImg2" className="b" draggable="false" />
          <a href="https://elitespecialsolutions.com">
            {textContent?.hero?.link}
          </a>
        </div>
      </section>

      <NavBar
        tab={tab}
        setTab={handleTabChange}
        getTabPath={(tabId) => tabRoutes[tabId]}
        user={typeUser}
        setLanguage={setLanguage}
        textContent={textContent}
      />

      <motion.div
        className="contact-button-section"
        initial={{ y: "100%", opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
      >
        <div style={{ display: contactBtn ? "" : "none" }}>
          <button className="sub-btn">
            <a
              href={data.socialMedia.whatsApp0 || data.socialMedia.whatsApp0}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </button>

          <button className="sub-btn">
            <a
              href={data.socialMedia.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
          </button>

          <button className="sub-btn">
            <a
              href={data.socialMedia.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </button>

          {/* 
          <button className="sub-btn">
            <a
              href={data.socialMedia.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
          </button>
          
          
          <button className="sub-btn">
            <a
              href={data.socialMedia.youtube}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>
          </button>*/}
        </div>
        <button>
          <RiContactsFill onClick={() => setcontactBtn(!contactBtn)} />
        </button>
      </motion.div>

      {/* Contenedor principal de contenido */}
      <div className="container" id="main-tab">
        {/* Pestaña Main 0*/}
        <Home tab={tab} setTab={handleTabChange} textContent={textContent}/>

        {/* About Us 4*/}
        <AboutUs tab={tab} setTab={handleTabChange} textContent={textContent}/>

        {/* Pestaña Our Expertise 1*/}
        <OurExpertise tab={tab} setTab={handleTabChange} textContent={textContent}/>

        {/* Pestaña Outsourcing Solutions 1*/}
        <OutsourcingSolutions tab={tab} setTab={handleTabChange} textContent={textContent}/>

        {/* Contact 3*/}
        <Contact tab={tab} data={data} setTab={handleTabChange} user={typeUser} textContent={textContent}/>

        {/* Careers 5*/}
        <Careers tab={tab} answer={answer} setTab={handleTabChange} setAns={setAns} textContent={textContent}/>
      </div>

      <Footer tab={tab} setTab={handleTabChange} data={data} textContent={textContent}/>
    </>
  );
}

export default Main;
